import React, { useState } from 'react';
import UsersTokenPlanTokensAdminList from './components/UsersTokenPlanTokensAdminList';
import { Box, Tabs, Tab } from '@mui/material';



const UsersTokenPlanTokensAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List user's Tokens" />
        {/*<Tab label="Add User Tokens" />*/}
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <UsersTokenPlanTokensAdminList />}

      </Box>
    </Box>
  );
};

export default UsersTokenPlanTokensAdminPage;